import { BrowserRouter as Router, Route, Switch } from "react-router-dom";

import About from "../pages/Frontend/about";
import Contact from "../pages/Frontend/contact";
import Faq from "../pages/Frontend/faq";
import Homepage from "../pages/Frontend/homepage";
import Login from "../pages/Frontend/login";
import Plan from "../pages/Frontend/plans";
import Register from "../pages/Frontend/register";
import DashboardRoute from "./DashboardRoute";

const Home = () => {
  return (
    <Router>
      <div className="app">
        <Switch>
          <Route exact path="/">
            <Homepage />
          </Route>
          <Route path="/plans">
            <Plan />
          </Route>
          <Route path="/about">
            <About />
          </Route>
          <Route path="/faq">
            <Faq />
          </Route>
          <Route path="/contact">
            <Contact />
          </Route>
          <Route path="/login">
            <Login />
          </Route>
          <Route path="/register">
            <Register />
          </Route>

          <Route path="/dashboard">
            <DashboardRoute />
          </Route>
        </Switch>
      </div>
    </Router>
  );
};

export default Home;
